import { createSelector } from 'reselect';

const getReducer = state => state.groups;

export const currentTabSelector = createSelector(
  state => getReducer(state).currentTab,
  currentTab => currentTab
);

export const errorMessageSelector = createSelector(
  state => getReducer(state).errorMessage,
  errorMessage => errorMessage
);

export const groupIdSelector = createSelector(
  state => getReducer(state).groupId,
  groupId => groupId
);

export const groupNameSelector = createSelector(
  state => getReducer(state).groupName,
  groupName => groupName
);

export const groupContextSelector = createSelector(
  state => getReducer(state).context,
  context => context
);

export const favIdSelector = createSelector(
  state => getReducer(state).favId,
  favId => favId
);

export const favNameSelector = createSelector(
  state => getReducer(state).name,
  name => name
);

export const detailsSelector = createSelector(
  state => getReducer(state).details,
  details => details
);

export const showSelector = createSelector(
  state => getReducer(state).show,
  show => show
);

export const showDeleteSelector = createSelector(
  state => getReducer(state).showDelete,
  showDelete => showDelete
);
